import React from "react";

interface UserAvatarProps {
  name: string;
  photoUrl?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-[24px] h-[24px] text-xs",
  md: "w-[30px] h-[30px] text-sm",
  lg: "w-[40px] h-[40px] text-base",
};

export const UserAvatar: React.FC<UserAvatarProps> = ({ name, photoUrl, size = "md", className = "" }) => {
  const sizeClass = sizeClasses[size];
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <div
      className={`rounded-full flex items-center justify-center border-solid border bg border-[#f5f6f8] cursor-pointer overflow-hidden ${
        photoUrl ? "" : "bg-primary-color"
      } ${sizeClass} ${className}`}
    >
      {photoUrl ? <img alt={name} src={photoUrl} className="object-cover w-full h-full" /> : <span className="!font-poppins text-white">{initials}</span>}
    </div>
  );
};
